import { useState } from "react";
import { ExternalLink, FolderKanban, Image, LayoutDashboard, LogOut, Menu, Settings, ShieldCheck, Users, Wrench, X } from "lucide-react";
import { Link, NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const navigation = [
  ["/admin", "Overview", LayoutDashboard, true],
  ["/admin/cover", "Homepage cover", Image],
  ["/admin/projects", "Projects", FolderKanban],
  ["/admin/clients", "Clients", Users],
  ["/admin/services", "Services", Wrench],
  ["/admin/settings", "Site settings", Settings],
  ["/admin/access", "Admin access", ShieldCheck],
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const [open, setOpen] = useState(false);
  if (loading) return <div className="admin-loading" data-testid="admin-auth-loading">Checking access…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return <div className="admin-shell" data-testid="admin-dashboard-shell">
    <aside className={`admin-sidebar ${open ? "is-open" : ""}`}>
      <div className="admin-sidebar-head"><img src="/ncp-mechanical-logo.png" alt="NCP Mechanical Ltd" /><button onClick={() => setOpen(false)} data-testid="admin-sidebar-close-button"><X /></button></div>
      <span className="admin-nav-label">Workspace</span>
      <nav data-testid="admin-navigation">{navigation.map(([to, label, Icon, end]) => <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} data-testid={`admin-nav-${label.toLowerCase().replace(" ", "-")}`}><Icon />{label}</NavLink>)}</nav>
      <div className="admin-sidebar-foot"><div><small>Signed in as</small><strong data-testid="admin-user-email">{user.email}</strong></div><button onClick={logout} data-testid="admin-logout-button"><LogOut /> Sign out</button></div>
    </aside>
    <div className="admin-main">
      <header className="admin-topbar"><button className="admin-menu-button" onClick={() => setOpen(true)} data-testid="admin-sidebar-open-button"><Menu /></button><div><span>LIVE CONTENT SYSTEM</span><strong data-testid="admin-current-user-name">{user.name}</strong></div><Link to="/" data-testid="admin-view-site-link">View website <ExternalLink /></Link><button className="admin-mobile-logout" onClick={logout} data-testid="admin-mobile-logout-button"><LogOut /></button></header>
      <Outlet />
    </div>
  </div>;
}